var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-view":"dolo.history.v0.12020"}},[_vm._v(" This is the History View ")])}
var staticRenderFns = []

export { render, staticRenderFns }